// src/pages/Login.js
import React, { useState } from "react";
import { loginUser, getUserAccess } from "../api/api";
import md5 from "md5";
import logo from "../assets/logo.png";

const Login = ({ setUser }) => {
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const hashedPassword = md5(password);
      const result = await loginUser(userId, hashedPassword);

      if (result.status === "success") {
        const accessResult = await getUserAccess(userId);

        const userData = {
          userId,
          name: result.nm_user,
          jabatan: result.level_user,
          access: accessResult.access || [],
        };

        localStorage.setItem("user", JSON.stringify(userData));
        setUser(userData); // 🔥 ini yang trigger Dashboard
      } else {
        setMessage(result.message || "Login gagal");
      }
    } catch (err) {
      setMessage("Terjadi kesalahan koneksi");
    }

    setLoading(false);
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <img src={logo} alt="Logo" style={styles.logo} />

        <form onSubmit={handleLogin} style={styles.form}>
          <input
            type="text"
            placeholder="User ID"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
            style={styles.input}
            required
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
            required
          />

          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? "Loading..." : "Login"}
          </button>
        </form>

        {message && <p style={styles.error}>{message}</p>}
      </div>
    </div>
  );
};

const styles = {
  container: {
    background: "#f0f2f5",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  card: {
    background: "#fff",
    padding: "40px",
    borderRadius: "10px",
    boxShadow: "0 5px 25px rgba(0,0,0,0.1)",
    width: "100%",
    maxWidth: "400px",
    textAlign: "center",
  },
  logo: {
    height: "60px",
    marginBottom: "30px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  input: {
    padding: "12px 15px",
    fontSize: "16px",
    border: "1px solid #ccc",
    borderRadius: "6px",
  },
  button: {
    padding: "12px 15px",
    background: "#007bff",
    color: "#fff",
    fontSize: "16px",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  },
  error: {
    marginTop: "15px",
    color: "red",
    fontSize: "14px",
  },
};

export default Login;